import React, {Component} from 'react';
import '../style/updateTab.css'
import FormGroupTextArea from "./formGroupTextArea";
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import FormResponseMessage from "./formResponseMessage";
import GeneralSVG from "./generalSVG";
import '../style/overviewTab.css'
import Pagination from "./pagination";
import FormGroupPlainText from "./formGroupPlainText";
import Button from "./button";
import TruncateMarkup from 'react-truncate-markup';
import moment from "moment";
import CenteredDots from "./General/centeredDots";
import OverviewTabFormFile from "./ApplicationPolicy/overviewTabFormFile";
import Popover from "./General/popover";
import {getOverviewCommentTitle} from "../helpers/policy/function";
import InfoLabel from './infoLabel';
import { COMMENT_AREA_INFO_MESSAGE } from '../helpers/variables';
import {parseComment} from '../helpers/commentParser'

class OverviewTab extends Component {
    constructor(props) {
		super(props);
		this.state = {infoState: false};
	  }
    isIntoView = (element) => {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    };

    focusOnComment = (commentId) => {
        if(!this.isIntoView(this.refs['ref' + commentId])) {
            this.refs['ref' + commentId].scrollIntoView();
        }
    };

    render(){
        const parse = require('html-react-parser');
        const infoMessageText = parse(COMMENT_AREA_INFO_MESSAGE)

        if(this.props.overviewTab.fetching){
            return (
                <div className="col-sm-12">
                    <CenteredDots/>
                </div>
            )
        }

        let featuredOverviewData = this.props.overviewTab.applicationOverview;
        let overviewData = [];
        let overviewDataLength;
        overviewData = this.props.CalculateFeaturedOverview()[0];
        overviewDataLength = this.props.CalculateFeaturedOverview()[1];
        let totalDisplayBoxes = Math.ceil(overviewDataLength / 10);
        let rows = overviewData.map((item, index) => {
            let commentVisibilityText="";
            if(this.props.UserRole !== "Solicitor") {
                if (item.visibleByMedical && item.visibleBySolicitor) {
                    commentVisibilityText = "Visible to all";
                } else if (item.visibleByMedical) {
                    commentVisibilityText = "Visible to ARAG and medical expert";
                } else {
                    commentVisibilityText = "Visible to ARAG";
                }
            }
            let document = ( ( item.attachments) && (
                <div>
                    {item.attachments.map((attachment, index) => {
                        return (
                            <div key={index}>
                                <span className="">
                    {'\"'}{attachment.name}{'\"'}
                                    {
                                        attachment !== null ?
                                            attachment.tags !== '' ?
                                                <span>{' - '}{attachment.tags}</span>
                                                :
                                                null
                                            :
                                            null
                                    }
				</span>
                                <div className="">
                                    <a onClick={() => {this.props.requestApplicationAttachment({applicationId: this.props.selectedApplication.id,attachmentId:attachment.id, relativeUrl:attachment.relativeUrl});}}
                                       className="applicationPolicy-document-tab-link">
                                        <GeneralSVG
                                            SvgWrapper="generalTab-download-wrapper"
                                            Label="Download"
                                            Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><title>Asset 9</title>
                                                <g id="Layer_2" data-name="Layer 2">
                                                    <g id="info">
                                                        <path
                                                            d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                        <path
                                                            d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                    </g>
                                                </g>
                                            </svg>}
                                        />
                                    </a>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ));
    
            const comment =  parseComment(item.comment);
            return (
                <div ref={'ref' + item.id} className="form-group" key={index}>
                    <div className="col-sm-3">
                        <div className="manageSolicitorAccount-data">{item.fullName}</div>
                        {moment(item.created).format('DD/MM/YYYY - HH:mm:ss')} <br/>
                        {commentVisibilityText}
                    </div>
                    <div className="col-sm-8">
                        <strong>
                            {getOverviewCommentTitle(item)}
                        </strong>
                        <div className="">
                            {
                                this.props.overviewTab.readMore[item.id] ?
                                    <div>
                                        <div className="overviewTab-break-line">
                                            { comment }
                                        </div>
                                        <div onClick={() => {
                                            this.focusOnComment(item.id);
                                            this.props.ChangeOverViewTabReadMoreState(item.id, false);
                                        }}>
                                            <GeneralSVG
                                                SvgWrapper="generalTab-readMore-wrapper"
                                                Label={'Read less' }
                                                Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.6 16"><title>Asset
                                                    2</title>
                                                    <g id="Layer_2" data-name="Layer 2">
                                                        <g id="Layer_1-2" data-name="Layer 1">
                                                            <path
                                                                d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                                        </g>
                                                    </g>
                                                </svg>}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <TruncateMarkup
                                        lines={3}
                                        ellipsis={<div><span> ... <br/><div
                                            onClick={() => {
                                                this.props.ChangeOverViewTabReadMoreState(item.id, true)
                                            }}><GeneralSVG
                                                SvgWrapper="generalTab-readMore-wrapper"
                                                Label={'Read More'}
                                                Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.6 16"><title>Asset 2</title>
                                                    <g id="Layer_2" data-name="Layer 2">
                                                        <g id="Layer_1-2" data-name="Layer 1">
                                                            <path
                                                                d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                                        </g>
                                                    </g>
                                                </svg>}
                                        /></div></span></div>}
                                    >
                                        <div className="overviewTab-break-line">
                                            { comment }
                                        </div>
                                    </TruncateMarkup>
                            }
                            {document}
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <hr className="generalTab-hr"/>
                    </div>
                </div>
            )
        });


        return (
            <div className="col-sm-12 updateTab-Wrapper">
                <form className="form-horizontal" onSubmit={(evt) => {
                    evt.preventDefault();
                    this.props.handleSubmit(evt)
                }}>
                    <FormGroupTextArea
                        centerWrapper="col-sm-6 formGroupTextArea-wrapper"
                        Required={false}
                        Label="Please add your comment"
                        Name="comments"
                        key="comment"
                        Value={this.props.overviewTab.comments}
                        HandleInputChange={this.props.HandleInputChange}
                        RightWrapper='infoBoxComment'
                        rightData={<InfoLabel
                            Value={infoMessageText}
                            infoState={this.state.infoState} Name="live"
                            onMouseOverHandler={() => this.setState({ infoState: !this.state.infoState })}
                        />}
                    />
                    {
                        this.props.overviewTab.attachments.map( (attachment, index) => {
                            return (
                                <OverviewTabFormFile
                                    onAttachmentDrop={this.props.OnDrop}
                                    changeOverviewAttachment={this.props.changeOverviewAttachment}
                                    attachmentIndex={index}
                                    removeOverviewAttachment={this.props.removeOverviewAttachment}
                                    key={index}
                                    attachment={attachment}/>
                            )
                        })
                    }
                    <div className="form-group" >
                        <div className="col-sm-3">
                            <label className="control-label.text-left "></label>
                        </div>
                        <div className="col-sm-6 ">
                            <div
                                className="overviewTab__add-attachment-btn "
                                onClick={this.props.addAnotherOverviewAttachment}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 7.2 12"><title>Asset 1</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                        <g id="info">
                                            <path
                                                d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                        </g>
                                    </g>
                                </svg>
                                <span >Add attachment</span>
                            </div>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className={'row'}>
                        <div className={'col-sm-9'}>
                            <span>{this.props.overviewTab.tagsDescription}</span>
                        </div>
                    </div>
                    {
                        this.props.UserRole !== 'Solicitor' ?
                            <div>
                                <FormGroupPlainText
                                    LeftWrapper="col-sm-3"
                                    Label="All"
                                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                                    Text={
                                        <Popover
                                            title={'Are you sure?'}
                                            onAccept={(evt) => {
                                                this.props.CheckUserOverviewTabCheckBox('all')
                                            }}
                                        >
                                            <input
                                                id="all"
                                                type="checkbox"
                                                className="appFormRefSettings-check_box"
                                                checked={this.props.ApplicationPolicyStore.usersOverviewTabCheckBoxes.all}
                                                name="closedAndRejected"
                                            />
                                            <label htmlFor="all"/>
                                        </Popover>
                                    }
                                />
                                <FormGroupPlainText
                                    LeftWrapper="col-sm-3"
                                    Label="ARAG"
                                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                                    Text={<div>
                                        <input id="arag" type="checkbox" className="appFormRefSettings-check_box"
                                               checked={this.props.ApplicationPolicyStore.usersOverviewTabCheckBoxes.arag}
                                               name="closedAndRejected"
                                               onChange={(evt) => {
                                                   this.props.CheckUserOverviewTabCheckBox('arag')
                                               }}/>
                                        <label htmlFor="arag"></label>
                                    </div>}/>
                                <FormGroupPlainText
                                    LeftWrapper="col-sm-3"
                                    Label="ARAG and medical experts"
                                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                                    Text={<div>
                                        <input id="aragAndMedicalExperts" type="checkbox"
                                               className="appFormRefSettings-check_box"
                                               checked={this.props.ApplicationPolicyStore.usersOverviewTabCheckBoxes.aragAndMedicalExperts}
                                               name="closedAndRejected"
                                               onChange={(evt) => {
                                                   this.props.CheckUserOverviewTabCheckBox('aragAndMedicalExperts')
                                               }}/>
                                        <label htmlFor="aragAndMedicalExperts"></label>
                                    </div>}
                                />
                                <div style={{display: 'none'}}>
                                    <FormGroupPlainText
                                        LeftWrapper="col-sm-3"
                                        Label="Send email notification"
                                        InputWrapper="manageSolicitorAccount-data col-sm-6"
                                        Text={<div>
                                            <input
                                                id="sendEmailNotificationOverview"
                                                type="checkbox"
                                                className="appFormRefSettings-check_box"
                                                checked={this.props.overviewTab.sendEmailNotification}
                                                name="sendEmailNotification"
                                                onChange={(evt) => {this.props.HandleInputChange(evt.target.name, !this.props.overviewTab.sendEmailNotification)}}
                                                disabled={!this.props.ApplicationPolicyStore.usersOverviewTabCheckBoxes.all}
                                            />
                                            <label htmlFor="sendEmailNotificationOverview"></label>
                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font"></span>
                                        </div>}
                                    />
                                </div>
                            </div>
                            :
                            null
                    }
                    <div className="form-group">
                        <div className="col-sm-3">
                        </div>
                        <div className="col-sm-6 ">
                            <Button
                                wrapper="btn-wrapper-forForms"
                                btnType="submit"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="Submit"
                            />
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    {
                        this.props.overviewTab.posting ?
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <div className="col-sm-5"></div>
                                    <Dots/>
                                </div>
                            </div>
                            : null
                    }
                    {
                        (this.props.overviewTab.badMsg !== '') ?
                            <FormResponseMessage Message={this.props.overviewTab.badMsg}
                                                 LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-6 formResponseMessage-size-wrapper"
                                                 MessageStyle="formResponseMessage-reject"/>
                            :
                            null
                    }
                    {
                        (this.props.overviewTab.msg !== '') ?
                            <FormResponseMessage Message={this.props.overviewTab.msg}
                                                 LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-6 formResponseMessage-size-wrapper"
                                                 MessageStyle="formResponseMessage-success "/>
                            :
                            null
                    }
                </form>
                <div className="row">
                    <div className="col-sm-12">
                        <hr className=" applicationPolicy-hr"/>
                    </div>
                </div>
                {
                    this.props.overviewTab.fetchingOverviewErrorMessage?
                        <div className={'row'}>
                            <FormResponseMessage Message={this.props.overviewTab.fetchingOverviewErrorMessage}
                                                 CenterWrapper="col-sm-12"
                                                 MessageStyle="formResponseMessage-reject"
                            />
                        </div>
                        :
                        <div className="form-horizontal">
                            {rows}
                            {
                                this.props.overviewTab.applicationOverview.length > 0 ?
                                    <Pagination PageShift={this.props.PageShift} HandleInputChange={this.props.HandleInputChange}
                                                TotalDisplayBoxes={totalDisplayBoxes}
                                                TotalRecords={overviewDataLength}
                                                Page={this.props.overviewTab.page} SelectedView={10}
                                                DataLength={featuredOverviewData.length}/>
                                    :
                                    null
                            }
                        </div>
                }
            </div>
        )
    }
}

export default OverviewTab;